import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../Components/Profile/ProfilePage.css";
import { useDispatch, useSelector } from "react-redux";
import { LOAD_USER_SUCCESS } from '../Constants/userConstants.js';
import axios from "axios";

const Profile = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { isAuth, user } = useSelector((state) => state.user);
  const [message, setMessage] = useState('');
  const [formState, setFormState] = useState({
    username: '',
    email: '',
    profilePic: ''
  });
  const [picDisplay, setPicDisplay] = useState();

  useEffect(() => {
    if (user) {
      let newForm = {};
      if (user.username){
        newForm.username = user.username;
      }
      if (user.email){
        newForm.email = user.email;
      }
      if (user.profilePic && user.profilePic.url){
        newForm.profilePic = user.profilePic.url;
        setPicDisplay(user.profilePic.url);
      }
      setFormState(newForm);
    }
    if (!isAuth) {
      navigate('/');
    }
  }, [isAuth, user, navigate]);
  //eslint warnings are to say that this variable may change, do we want to re-run when it changes.
  //will need to add navigate as dependency if navigating using relative paths.
  //ie. add navigate if you think that hte path will change.
  //i don't think so, but it shouldn't break this if navigate changes.

  useEffect(() => {
    if (isAuth && user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
            document.documentElement.style.setProperty('--font-size-header', '1.5vw');
            document.documentElement.style.setProperty('--font-size-label', '14p');
            document.documentElement.style.setProperty('--font-size-input', '14px');
            document.documentElement.style.setProperty('--font-size-button', '0.8vw');
            break;
        case 1: // Medium (default)
            document.documentElement.style.setProperty('--font-size-header', '2vw');
            document.documentElement.style.setProperty('--font-size-label', '16px');
            document.documentElement.style.setProperty('--font-size-input', '16px');
            document.documentElement.style.setProperty('--font-size-button', '1vw');
            break;
        case 2: // Large
            document.documentElement.style.setProperty('--font-size-header', '3vw');
            document.documentElement.style.setProperty('--font-size-label', '24px');
            document.documentElement.style.setProperty('--font-size-input', '24px');
            document.documentElement.style.setProperty('--font-size-button', '2vw');
            break;
        default:
          break;
      }
    } else if (!isAuth) {
      document.documentElement.style.setProperty('--font-size-header', '2vw');
      document.documentElement.style.setProperty('--font-size-label', '16px');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-button', '1vw');
    }
  }, [user, isAuth]);
  
  const updateProfilePic = (e) => {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setFormState({
          ...formState,
          profilePic : reader.result
        });
        setPicDisplay(reader.result);
        console.log(formState);
      }
    };

    reader.readAsDataURL(e.target.files[0]);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      // Send login request to backend
      let newForm = formState;
      if (formState.profilePic && (formState.profilePic === user.profilePic.url)){
        newForm.profilePic = '';
      }
      await axios.put('/api/v1/users/me/update', newForm);

      const loadUser = await axios.get('api/v1/users/me');
      // console.log(response.data.user);
      if (loadUser.data.user){
        dispatch({ type: LOAD_USER_SUCCESS, payload: loadUser.data.user });
      }

      setMessage('Profile updated successfully');
    } catch (error) {
      // Handle error
      if (error.response && error.response.data) {
        setMessage(error.response.data.message || 'An error occurred');
      } else {
        setMessage('An error occurred');
      }
      console.error('Update error:', error);
      setMessage(`Error while updating: ${error}`);
    }
  };

  const handleAccountSettingsClick = () => {
    navigate('/preferences');
  };

  return (
    <div className="profile">
      <div className="profile-content">
        <h1>My Profile</h1>
        <div className="profile-details">
          <div className="profile-image-section">
            <div className="profile-image">
              {picDisplay && <img className="profile-pic" src={picDisplay} alt="profile" ></img>}
            </div>
            <label className="change-photo-button">
              <input
                    type="file"
                    name="profile-pic"
                    accept="image/*"
                    onChange={updateProfilePic}
              />
              Change Photo
            </label>
          </div>
          <div className="profile-form-section">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Username</label>
              <input 
                type="text" 
                name="username"
                value={formState.username}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input 
                type="email" 
                name="email"
                value={formState.email}
                onChange={handleChange} 
              />
            </div>
            {message && <div className="message">{message}</div>}  {/* Display message */}
            <button className="update-profile-button" type="submit">
              Update Profile
            </button>
            <button className="account-settings-button" onClick={handleAccountSettingsClick}>
              Account Settings
            </button>
          </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
